 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-054765b0":"38b83c61","chunk-08048404":"a11e9fa7","chunk-0b790d3a":"c1d31311","chunk-0ffe4d63":"67e651e6","chunk-101b7cbb":"59513071","chunk-1220b765":"356e0bed","chunk-1b1cb0df":"47ffbd0f","chunk-1cc362b4":"9b959eea","chunk-257f44e4":"edd57275","chunk-2696f911":"6388d12c","chunk-2d0b9087":"164e0714","chunk-4e3a31e2":"fc72f63a","chunk-aa9ec960":"739be215","chunk-84c2d93e":"97e3f12b","chunk-4a8a0508":"fe60a938","chunk-d293453a":"60467e34","chunk-d8228b32":"7360ec5d","chunk-0530fbe3":"53c49d75","chunk-0ad0ca73":"3138c990","chunk-1150cf9a":"00ef0422","chunk-1d970094":"fdceea76","chunk-1e624c61":"d8890ed5","chunk-55ead48c":"2d3c1b32","chunk-83e8b2d4":"e1a0b39a","chunk-895b11ec":"224bdf13","chunk-0402399b":"79efd93d","chunk-06c52a52":"8c68c70f","chunk-07ad53c4":"45315e08","chunk-18b3b545":"ac61811c","chunk-2e247f00":"c4d0cdda","chunk-2e8e66f2":"7ee565bb","chunk-49a64c42":"c8a13349","chunk-50b9b71e":"c163a4b0","chunk-5dd1c532":"89e258b5","chunk-688e7d76":"07478a6c","chunk-6cdf394c":"7562b0fd","chunk-c21b9abc":"252e699b","chunk-e721904a":"f2d53f7c","chunk-f3c573f0":"b4483a7a","chunk-a2aa1cf2":"a57764b9","chunk-c42165e2":"decf3ae3","chunk-f7ed3b98":"977878a3","chunk-289bc6e6":"88460816","chunk-29a7a554":"d49502dc","chunk-2bc4099d":"ff4d1d18","chunk-2d0d7125":"dd4b593f","chunk-2d20f987":"5e0f6986","chunk-3167496f":"cbac7c2e","chunk-351c3c8c":"69c9530f","chunk-35a1eeaa":"eb0255b9","chunk-4131a008":"f324ce31","chunk-41f3ff24":"0a1afb36","chunk-4458d407":"77acea63","chunk-45d388ee":"82c5fef0","chunk-478cd751":"e9fa05b3","chunk-572f0ea3":"99e15a43","chunk-60e66058":"081d9aa2","chunk-618971b7":"3b56e52f","chunk-62c19a00":"b6b47661","chunk-658b3ed4":"b2e427ff","chunk-69b3a464":"0106b6cc","chunk-6c800da9":"ae87f924","chunk-75b5d810":"6b24ddaa","chunk-79929d5f":"9b7556e0","chunk-7c05d970":"fecce4a5","chunk-7dbf9dc3":"ef1a0189","chunk-97705c9e":"4e38c3be","chunk-ab313df2":"a682ffa8","chunk-b07991ce":"b28036ff","chunk-bcd18cd2":"73a2032c","chunk-d198d6e6":"a3318204","chunk-d45ffdaa":"5754d689","chunk-e8533ae6":"d74fb3f3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-08048404":1,"chunk-0b790d3a":1,"chunk-0ffe4d63":1,"chunk-101b7cbb":1,"chunk-1220b765":1,"chunk-1b1cb0df":1,"chunk-1cc362b4":1,"chunk-257f44e4":1,"chunk-4e3a31e2":1,"chunk-84c2d93e":1,"chunk-d293453a":1,"chunk-d8228b32":1,"chunk-0530fbe3":1,"chunk-0ad0ca73":1,"chunk-1d970094":1,"chunk-1e624c61":1,"chunk-55ead48c":1,"chunk-83e8b2d4":1,"chunk-895b11ec":1,"chunk-0402399b":1,"chunk-06c52a52":1,"chunk-07ad53c4":1,"chunk-18b3b545":1,"chunk-2e247f00":1,"chunk-2e8e66f2":1,"chunk-49a64c42":1,"chunk-50b9b71e":1,"chunk-5dd1c532":1,"chunk-688e7d76":1,"chunk-6cdf394c":1,"chunk-c21b9abc":1,"chunk-e721904a":1,"chunk-f3c573f0":1,"chunk-a2aa1cf2":1,"chunk-c42165e2":1,"chunk-f7ed3b98":1,"chunk-289bc6e6":1,"chunk-29a7a554":1,"chunk-2bc4099d":1,"chunk-3167496f":1,"chunk-4131a008":1,"chunk-41f3ff24":1,"chunk-4458d407":1,"chunk-45d388ee":1,"chunk-478cd751":1,"chunk-572f0ea3":1,"chunk-60e66058":1,"chunk-618971b7":1,"chunk-69b3a464":1,"chunk-6c800da9":1,"chunk-75b5d810":1,"chunk-79929d5f":1,"chunk-7c05d970":1,"chunk-7dbf9dc3":1,"chunk-ab313df2":1,"chunk-b07991ce":1,"chunk-bcd18cd2":1,"chunk-d198d6e6":1,"chunk-d45ffdaa":1,"chunk-e8533ae6":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-054765b0":"31d6cfe0","chunk-08048404":"998b4bec","chunk-0b790d3a":"b25d9462","chunk-0ffe4d63":"0fea5eb4","chunk-101b7cbb":"0fea5eb4","chunk-1220b765":"0fea5eb4","chunk-1b1cb0df":"0fea5eb4","chunk-1cc362b4":"515c1c00","chunk-257f44e4":"69f49ad3","chunk-2696f911":"31d6cfe0","chunk-2d0b9087":"31d6cfe0","chunk-4e3a31e2":"d46999d9","chunk-aa9ec960":"31d6cfe0","chunk-84c2d93e":"c265ebf2","chunk-4a8a0508":"31d6cfe0","chunk-d293453a":"803704ae","chunk-d8228b32":"7ed68092","chunk-0530fbe3":"7ddcfb41","chunk-0ad0ca73":"45f8fe76","chunk-1150cf9a":"31d6cfe0","chunk-1d970094":"4417157e","chunk-1e624c61":"3fe9053a","chunk-55ead48c":"1dd906c6","chunk-83e8b2d4":"81408fe2","chunk-895b11ec":"305ac993","chunk-0402399b":"f2bfa989","chunk-06c52a52":"bc428ea5","chunk-07ad53c4":"51131af9","chunk-18b3b545":"51131af9","chunk-2e247f00":"f102feed","chunk-2e8e66f2":"279db7a3","chunk-49a64c42":"01ea12fd","chunk-50b9b71e":"51131af9","chunk-5dd1c532":"026dc6ea","chunk-688e7d76":"51131af9","chunk-6cdf394c":"c729090a","chunk-c21b9abc":"51131af9","chunk-e721904a":"51131af9","chunk-f3c573f0":"70823f35","chunk-a2aa1cf2":"81f7fe30","chunk-c42165e2":"92517b11","chunk-f7ed3b98":"03fcf382","chunk-289bc6e6":"43100682","chunk-29a7a554":"4260a159","chunk-2bc4099d":"5f39dad0","chunk-2d0d7125":"31d6cfe0","chunk-2d20f987":"31d6cfe0","chunk-3167496f":"0fea5eb4","chunk-351c3c8c":"31d6cfe0","chunk-35a1eeaa":"31d6cfe0","chunk-4131a008":"26487049","chunk-41f3ff24":"72bdbb34","chunk-4458d407":"089e54e8","chunk-45d388ee":"0fea5eb4","chunk-478cd751":"b6bdef01","chunk-572f0ea3":"f94a60c9","chunk-60e66058":"22ccf886","chunk-618971b7":"5465d815","chunk-62c19a00":"31d6cfe0","chunk-658b3ed4":"31d6cfe0","chunk-69b3a464":"0fea5eb4","chunk-6c800da9":"a6bb29f3","chunk-75b5d810":"521b9b2c","chunk-79929d5f":"009443c6","chunk-7c05d970":"8739dd6a","chunk-7dbf9dc3":"f293ed19","chunk-97705c9e":"31d6cfe0","chunk-ab313df2":"7121534d","chunk-b07991ce":"8c7707d8","chunk-bcd18cd2":"0fea5eb4","chunk-d198d6e6":"0fea5eb4","chunk-d45ffdaa":"22ccf886","chunk-e8533ae6":"0fea5eb4"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/platform/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
